<script lang="ts">
  import { melt } from "@melt-ui/svelte";
  import { createSwitch } from "@melt-ui/svelte";

  import type { Writable } from "svelte/store";

  interface Props {
    label?: string | undefined;
    disabled?: boolean;
    defaultChecked?: boolean;
    /** Controlled checked state. Pass a `Writable<boolean>` store for melt-ui integration. */
    checked?: Writable<boolean>;
    /** Callback invoked when the checked state changes. Replaces the legacy `on:checkedChange` event. */
    onCheckedChange?: (checked: boolean) => void;
  }

  let {
    label = undefined,
    disabled = false,
    defaultChecked = false,
    checked,
    onCheckedChange,
  }: Props = $props();

  const {
    elements: { root, input },
    // svelte-ignore state_referenced_locally
  } = createSwitch({
    disabled,
    defaultChecked,
    checked: checked,
    onCheckedChange: ({ next }) => {
      onCheckedChange?.(next);
      return next;
    },
  });
</script>

<div class="flex items-center">
  {#if label}
    <label class="pr-4 leading-none text-mono-900" for={label} id={label}>
      {label}
    </label>
  {/if}
  <button
    type="button"
    {...$root} use:$root.action
    class="relative h-5 rounded-full transition-colors
      {disabled
      ? 'cursor-not-allowed bg-mono-200 opacity-50 shadow-border-inset'
      : 'cursor-pointer bg-mono-300 focus-ring outline-transparent data-[state=checked]:bg-mono-900'}"
    id={label}
    aria-labelledby={label}
  >
    <span
      class="thumb absolute top-0.5 left-0.5 h-4 w-4 rounded-full shadow-border-inset transition-transform data-[state=checked]:translate-x-5
        {disabled ? 'bg-mono-300' : 'bg-mono-100'}"
    ></span>
  </button>
  <input {...$input} use:$input.action />
</div>

<style>
  @reference "#tailwind.css";
  button {
    --w: 2.2rem;
    --padding: 0.02rem;
    width: var(--w);
  }

  .thumb {
    --size: 1.25rem;
    transform: translateX(var(--padding));
  }

  :global([data-state="checked"]) .thumb {
    transform: translateX(calc(var(--w) - var(--size) - var(--padding)));
  }
</style>
